module.exports = __webpack_public_path__ + "img/shin5.486eec30.jpg";